// services/promoCodeApiService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_QWIK_MEDIC_API_URL;
const TOKEN = process.env.REACT_APP_QWIK_MEDIC_TOKEN;

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `${TOKEN}`,
    'Content-Type': 'application/json',
  },
});

export const promoCodeApiService = {
  // Get all promo codes
  getAllPromoCodes: async () => {
    try {
      const response = await axiosInstance.get('phoneNumbers/');
      return response.data.reverse(); // Show latest first
    } catch (error) {
      console.error('Error fetching promo codes:', error);
      throw error;
    }
  },

  // Get single promo code
  getPromoCode: async (id) => {
    try {
      const response = await axiosInstance.get(`phoneNumbers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching promo code:', error);
      throw error;
    }
  },

  // Create new promo code
  createPromoCode: async (promoData) => {
    try {
      const response = await axiosInstance.post('phoneNumbers/new', promoData);
      return response.data;
    } catch (error) {
      console.error('Error creating promo code:', error);
      throw error;
    }
  },

  // Update promo code
  updatePromoCode: async (id, promoData) => {
    try {
      const response = await axiosInstance.patch(`phoneNumbers/${id}`, promoData);
      return response.data;
    } catch (error) {
      console.error('Error updating promo code:', error);
      throw error;
    }
  },

  // Delete promo code
  deletePromoCode: async (id) => {
    try {
      await axiosInstance.delete(`phoneNumbers/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting promo code:', error);
      throw error;
    }
  },
};